import React, { useCallback, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
// import ImageS3 from "../../../../components/Images/S3Image";
// import { generateImage } from "../../../../utils/cloudinaryUtil";
// import { AdvancedImage, lazyload } from "@cloudinary/react";
import { useS3Upload } from "../../../../hooks/useS3Upload";
import ImageS3 from "../../../../components/Images/S3Image";

const SingleOpportunity = ({ index, item }) => {
  const [coverImageURL, setCoverImageURL] = useState("");

  const { getFile } = useS3Upload();

  const getS3URL = useCallback(
    async (key, callback) => {
      const uri = await getFile(key);
      setCoverImageURL(uri);
    },
    [getFile]
  );

  useEffect(() => {
    if (item && item.cover) {
      getS3URL(item.cover);
    }
  }, [item, getS3URL]);

  return (
    <div key={`ki${index}`} className="d-flex align-items-center mb-10">
      <NavLink to={`/opportunities/${item.id}/edit`}>
        <div className="symbol symbol-80 symbol-2by3 flex-shrink-0 mr-4">
          <ImageS3
            height="225px"
            width="100%"
            style={{ objectFit: "cover" }}
            photo={coverImageURL}
          />
        </div>
      </NavLink>
      <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
        <NavLink
          to={`/opportunities/${item.id}/edit`}
          className="text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1"
        >
          {item.title}
        </NavLink>
        <span className="text-muted font-weight-bold">
          {item.opportunityType.name}
        </span>
      </div>
      <div className="d-flex align-items-center mt-lg-0 mt-3">
        {/* <div className="mr-6">
  <span className="text-dark-75 font-weight-bolder">4.2</span>
</div> */}
        <NavLink
          to={`/opportunities/${item.id}/edit`}
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
        >
          <span className="svg-icon svg-icon-success">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Navigation/Right-2.svg")}
            ></SVG>
          </span>
        </NavLink>
      </div>
    </div>
  );
};

export default SingleOpportunity;
